import React from 'react';
import { ProjectDocsFolderTree } from './ProjectDocsFolderTree';
import { ProjectDocsList } from './ProjectDocsList';

export function ProjectDocsExplorer() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
      {/* Cột trái: Cây thư mục (3/12) */}
      <div className="lg:col-span-3">
        <ProjectDocsFolderTree />
      </div>

      {/* Cột phải: Danh sách tài liệu (9/12) */}
      <div className="lg:col-span-9">
        <ProjectDocsList />
      </div>
    </div>
  );
}
